// extracted by mini-css-extract-plugin
export default {"BetaLabel":"RegexField-module__BetaLabel--RVcge","TestButton":"RegexField-module__TestButton--jzXPM"};